import axios from "axios";

// The crm-fig database via the figazuresql autoscaffold is the entire backend.
// No custom API, no tokens — auth is a client-side match against /usermst.
const USER_KEY = "sk12_admin_user";

export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));
export const clearStoredUser = () => localStorage.removeItem(USER_KEY);

export const api = axios.create({
  baseURL: "https://figazuresql.swancreate.com/api/crm",
});
